import type { SxProps, Theme } from '@mui/material'

export const styles = {
  container: {
    width: '100%',
    overflowX: 'auto',
  },

  table: {
    minWidth: 0,
  },
  headerCell: {
    fontWeight: 600,
    backgroundColor: 'background.paper',
  },
  /**
   * Strip the bottom border from the last body row so the body flushes
   * against the pagination border instead of doubling it up. Mirrors v1.
   */
  row: {
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  },
  rowClickable: {
    cursor: 'pointer',
  },
  pagination: {
    borderTop: '1px solid',
    borderColor: 'divider',
  },
  paginationActions: {
    display: 'flex',
    alignItems: 'center',
    gap: 0.25,
    ml: 1,
  },
  empty: {
    textAlign: 'center',
    color: 'text.secondary',
    py: 3,
  },
} satisfies Record<string, SxProps<Theme>>
